import { types } from "mobx-state-tree"

export const Role = types
    .model({
        id: types.optional(types.number, 0),
        name: types.optional(types.string, "")
    }).actions(self => ({

    }))